import { Injectable } from '@angular/core';
import { AUTOCOMPLETE_ENDPOINTS, AutocompleteType } from '@athlete-x/definitions';
import { HttpClient } from '@angular/common/http';

import { map } from 'rxjs';

@Injectable()
export class SchoolAutocompleteService {

    constructor(
        private _http: HttpClient,
    ) {
    }

    public fetchItems(query: string, type: AutocompleteType) {
        const params = {
            page: 1,
            query,
            per_page: 16
        };

        return this._http.get<any>(AUTOCOMPLETE_ENDPOINTS[type], { params })
            .pipe(
                map((data) => data?.data || data),
                map((items) => {
                    for (const item of items) {
                        if (item.nickname) {
                            item.name = item.nickname;
                        }
                    }

                    return items;
                })
            );
    }
}
